import { motion } from "framer-motion";

/**
 * BeatPulse — a small attention-pulse dot using the brand pulse color (#8B1A2E).
 * Use sparingly to draw the eye to a key moment.
 */
export const BeatPulse = ({ size = 10, label, className = "", color }) => {
  const dotColor = color || "rgba(139, 26, 46, 1)";
  // Extract rgba components for shadow animation
  const shadowFrom = color
    ? color.startsWith("#")
      ? `${color}8c`
      : color.replace(/rgba?\(([^)]+)\)/, (_, p) => `rgba(${p.split(",").slice(0, 3).join(",")}, 0.55)`)
    : "rgba(139, 26, 46, 0.55)";
  const shadowTo = color
    ? color.startsWith("#")
      ? `${color}00`
      : color.replace(/rgba?\(([^)]+)\)/, (_, p) => `rgba(${p.split(",").slice(0, 3).join(",")}, 0)`)
    : "rgba(139, 26, 46, 0)";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <motion.span
        className="relative inline-block rounded-full"
        style={{ width: size, height: size, background: dotColor }}
        animate={{
          boxShadow: [
            `0 0 0 0 ${shadowFrom}`,
            `0 0 0 14px ${shadowTo}`,
          ],
        }}
        transition={{
          duration: 2.4,
          repeat: Infinity,
          ease: "easeOut",
        }}
      />
      {label ? (
        <span className="text-xs uppercase tracking-[0.32em] text-white/70">
          {label}
        </span>
      ) : null}
    </span>
  );
};

export default BeatPulse;
